/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

var sections = window.theme.sections;
var slideshowAutoExtension = {
  init: function() {
    this.on('slideshow_desktop_init_done', this._autoplaySlideshow.bind(this));
  },
  _autoplaySlideshow:setInterval(function()  {
    var $slide = $('.slideshow__slide--active')
                   .removeClass('slideshow__slide--active');
    var $button = $('.slideshow__button--active')
                   .removeClass('slideshow__button--active');

    var $slides = $('.slideshow__slide');

    var currentIndex = ($slides.index($slide) + 1) % $slides.length;

    $slides
      .eq(currentIndex)
      .addClass('slideshow__slide--active');

    var $buttons = $('.slideshow__button')
      .eq(currentIndex)
      .addClass('slideshow__button--active');

  }, 9000)

};


(function() {
  function getSection(element) {
    return element.closest('[data-section-type="tabbed-collections"]');
  }

  function activateTab(section, tab, moveFocus) {
    var tabs = section.querySelectorAll('[data-tabbed-collections-tab]');
    var panels = section.querySelectorAll('[data-tabbed-collections-panel]');
    var panelId = tab.getAttribute('aria-controls');

    Array.prototype.forEach.call(tabs, function(item) {
      var isActive = item === tab;
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      item.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    Array.prototype.forEach.call(panels, function(panel) {
      panel.hidden = panel.id !== panelId;
    });

    if (moveFocus) {
      tab.focus();
    }
  }

  document.addEventListener('click', function(event) {
    var tab = event.target.closest('[data-tabbed-collections-tab]');

    if (!tab) return;

    activateTab(getSection(tab), tab, false);
  });

  document.addEventListener('keydown', function(event) {
    var tab = event.target.closest('[data-tabbed-collections-tab]');

    if (!tab) return;

    var section = getSection(tab);
    var tabs = Array.prototype.slice.call(
      section.querySelectorAll('[data-tabbed-collections-tab]')
    );
    var currentIndex = tabs.indexOf(tab);
    var nextIndex;

    if (event.key === 'ArrowRight') {
      nextIndex = (currentIndex + 1) % tabs.length;
    } else if (event.key === 'ArrowLeft') {
      nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = tabs.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    activateTab(section, tabs[nextIndex], true);
  });

  document.addEventListener('shopify:block:select', function(event) {
    var section = getSection(event.target);

    if (!section || !event.detail || !event.detail.blockId) return;

    var tab = section.querySelector(
      '[data-tabbed-collections-tab][data-block-id="' +
        event.detail.blockId +
        '"]'
    );

    if (tab) {
      activateTab(section, tab, false);
    }
  });
})();



(function() {
  document.addEventListener('toggle', function(event) {
    var item = event.target;

    if (!item.matches || !item.matches('[data-faq-item]') || !item.open) return;

    var section = item.closest('[data-section-type="faq-accordion"]');

    if (!section || section.getAttribute('data-single-open') !== 'true') return;

    var items = section.querySelectorAll('[data-faq-item]');

    Array.prototype.forEach.call(items, function(otherItem) {
      if (otherItem !== item) {
        otherItem.open = false;
      }
    });
  }, true);

  document.addEventListener('shopify:block:select', function(event) {
    var section = event.target.closest('[data-section-type="faq-accordion"]');

    if (!section || !event.detail || !event.detail.blockId) return;

    var item = section.querySelector(
      '[data-faq-item][data-block-id="' + event.detail.blockId + '"]'
    );

    if (item) {
      item.open = true;
    }
  });
})();
